import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRole } from '../../contexts/RoleContext';
import { ModuleId } from '../../types/auth';

// Composes with ProtectedRoute. ProtectedRoute gates "is signed in"; RoleGuard
// gates "does this role have access to this module." Place RoleGuard *inside*
// ProtectedRoute on a route definition.
//
// Client-side only — UX layer, not security. The Supabase login is the real
// auth gate; module-access enforcement should move server-side in Path B.

interface RoleGuardProps {
  moduleId: ModuleId;
  children: React.ReactNode;
}

const RoleGuard: React.FC<RoleGuardProps> = ({ moduleId, children }) => {
  const { can, appUser } = useRole();
  const location = useLocation();
  const allowed = can(moduleId);

  useEffect(() => {
    if (!allowed && appUser) {
      console.warn(`RoleGuard blocked: ${appUser.email} (${appUser.role}) → ${moduleId} at ${location.pathname}`);
    }
  }, [allowed, appUser, moduleId, location.pathname]);

  if (!allowed) {
    return <Navigate to="/" replace state={{ deniedModule: moduleId, deniedAt: location.pathname }} />;
  }
  return <>{children}</>;
};

export default RoleGuard;
